import { create, tsx } from '@dojo/framework/core/vdom';
import { Head } from '../../widgets/Head';
import { Text } from '../../widgets/Text';
import Image from '../../widgets/Image';
import Summary from '../../widgets/Summary';
import OpenSourcePage from './OpenSourcePage';

const dgridLogo = require('../../assets/images/logo/medium/dgrid.svg');

const factory = create();

export const OpenSourceDgrid = factory(function OpenSourceDgrid() {
	return (
		<OpenSourcePage background="level3Purple">
			{{
				head: (
					<Head
						title="dgrid | SitePen"
						description="A comprehensive, responsive, and modular data grid. Performant, scalable and embeddable within any application or framework including React and Angular."
					/>
				),
				hero: {
					title: 'Open Source',
					xlTitle: 'Dgrid'
				},
				page: (
					<Summary stack paddingBottom="md">
						{{
							image: <Image src={dgridLogo} size="sm" width={288} height={135} />,
							blurb: (
								<virtual>
									<Text type="large-body">
										Data grids are a common need for representing data in
										enterprise applications. Grids are challenging as browsers
										do not provide sufficient built-in APIs to reflect the wide
										variety of features needed by enterprises.
									</Text>
									<Text type="large-body">
										Prior to{' '}
										<a href="https://dgrid.io" target="_blank" rel="noopener">
											dgrid
										</a>
										, most data grid solutions either struggled immensely with
										performance issues due to a kitchen sink approach, or were
										incredibly limited in their capabilities. dgrid was the
										first grid component to provide both flexibility and
										efficient performance.
									</Text>
									<Text type="large-body">
										dgrid provides a flexible architecture for including data
										grid features incrementally, optimizing performance for only
										the features needed. From lazy-loading very large data sets
										to powerful features for configuring and controlling grid
										behavior, dgrid offers a powerful data grid component and
										though built over 10 years ago, is still maintained and in
										heavy use today.
									</Text>
								</virtual>
							)
						}}
					</Summary>
				)
			}}
		</OpenSourcePage>
	);
});

export default OpenSourceDgrid;
